import i18next from 'i18next';
import { initReactI18next, useTranslation } from 'react-i18next';
import moment from 'moment';
import 'moment/locale/en-ca';
import 'moment/locale/fr-ca';
import enJSON from './translations/en.json';
import frJSON from './translations/fr.json';
import { rbcDict } from './static/session';

const resources = {
  en: { translation: enJSON },
  fr: { translation: frJSON }
};

const params = new URLSearchParams(window.location.search);
const paramLng = params.get('LANGUAGE');
let lng = 'en';
if (paramLng && ['fr', 'french'].includes(paramLng.toLowerCase().trim()) ||
    !paramLng && rbcDict.language?.toLowerCase().trim() === 'french') {
  lng = 'fr';
}

document.documentElement.lang = lng;
moment.locale(lng);

i18next.use(initReactI18next)
  .init({
    resources,
    lng,
    keySeparator: false, // Not nesting keys
    interpolation: {
      escapeValue: false, // React already safe from xss,
      format: (value, format, lng) => {
        if (['number', 'compact', 'percent', 'percentfloat', 'currency', 'dollars', 'quoteprice', 'OtisMultiMsg'].includes(format)) {
          let opts: Intl.NumberFormatOptions = { minimumFractionDigits: 2, maximumFractionDigits: 4 };
          if (format === 'compact') {
            return Number(value).toLocaleString(`${lng}-ca`, { notation: 'compact', maximumFractionDigits: 1} as any);
          }
          if (format === 'number') {
            opts.minimumFractionDigits = 0;
          }
          else if (['percent', 'percentfloat'].includes(format)) {
            opts.style = 'percent';
            opts.maximumFractionDigits = 2;
            if (format === 'percent') {
              opts.minimumFractionDigits = 0;
            }
          }
          else if (['dollars', 'quoteprice'].includes(format)) {
            opts.style = 'currency';
            opts.currency = 'CAD';
            opts.currencyDisplay = 'symbol';
            if (format === 'quoteprice' && Math.abs(value) > 2) {
              opts.maximumFractionDigits = 2;
            }
            return Number(value).toLocaleString(`${lng}-ca`, opts).replace(/C(AD?)?/, '').trim();
          }
          else if (format === 'OtisMultiMsg') {
            let msg = '';
            return (() => {
            const { t } = useTranslation();
            value.toString().split(' ').forEach(el => {
              msg += t(`eq_error.${el}`);
            });
            return t('fmt_OtisMultiMsg', {otismsgs: msg});
          })();
          }
          return Number(value).toLocaleString(`${lng}-ca`, opts);
        }
        const momentDate = moment(value);
        if (momentDate.isValid()) return momentDate.format(format);
        return value;
      }
    },
    react: {
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'b', 'i', 'p']
    }
  });

export default i18next;
export { lng };
